// 黑料色色卡图鉴 · 数据层（仅静态展示用）

export type Category = {
  id: string;
  name: string;
  en: string;
  seq: string;
  tagline: string;
  sample: string;
};

export const colorCategories: Category[] = [
  { id: "carbon", name: "炭黑系", en: "Carbon Black", seq: "01", tagline: "极致纯净的深黑基底，适合高对比主色与深底应用。", sample: "#0a0a0b" },
  { id: "obsidian", name: "曜石系", en: "Obsidian", seq: "02", tagline: "带有冷光底调的深邃黑，多用于高光饰面与数码外壳。", sample: "#101014" },
  { id: "graphite", name: "石墨系", en: "Graphite", seq: "03", tagline: "沉稳的中深灰阶，介于黑白之间的结构与过渡。", sample: "#28282c" },
  { id: "smoke", name: "烟灰系", en: "Smoke Grey", seq: "04", tagline: "轻盈的浅灰层次，常用于版面底色与辅助描边。", sample: "#8a8a8f" },
  { id: "ink", name: "玄青·冷墨系", en: "Ink Blue", seq: "05", tagline: "偏冷微蓝的墨色，用于想避开纯黑死板感的场景。", sample: "#1b1e26" },
  { id: "warm", name: "暖黑·酱褐系", en: "Warm Espresso", seq: "06", tagline: "带棕红底蕴的温暖黑，皮革、木作与复古质感首选。", sample: "#241c17" },
];

export type Swatch = {
  id: string;
  code: string;
  name: string;
  hex: string;
  rgb: string;
  cmyk: string;
  categoryId: string;
  lightness: number; // 0-100 视觉明度
  sheen: "哑光" | "半光" | "高光";
  tone: "冷调" | "中性" | "暖调";
  tags: string[];
  use: string[];
  desc: string;
};

export const swatches: Swatch[] = [
  // 炭黑系
  { id: "s01", code: "HLC-0101", name: "玄墨", hex: "#0a0a0b", rgb: "10 · 10 · 11", cmyk: "10 · 10 · 5 · 92", categoryId: "carbon", lightness: 4, sheen: "高光", tone: "中性", tags: ["极黑", "高对比"], use: ["时装", "包装"], desc: "图鉴收录的最深一档纯黑，几乎吸收全部可见光，适合作为海报主视觉与高级时装的打底墨。" },
  { id: "s02", code: "HLC-0102", name: "浓炭", hex: "#0e0e0f", rgb: "14 · 14 · 15", cmyk: "7 · 7 · 4 · 95", categoryId: "carbon", lightness: 7, sheen: "半光", tone: "中性", tags: ["炭黑", "百搭"], use: ["建材", "家居"], desc: "略带半光质感的通用炭黑，既能承担大面积色块，也不会在弱光下显得闷平。" },
  { id: "s03", code: "HLC-0103", name: "京碳", hex: "#131314", rgb: "19 · 19 · 20", cmyk: "5 · 5 · 3 · 94", categoryId: "carbon", lightness: 12, sheen: "哑光", tone: "中性", tags: ["哑光", "耐看"], use: ["印刷", "数码"], desc: "哑光京碳颗粒感细腻，适合需要长时间观看的低反光界面与印刷深底。" },
  { id: "s04", code: "HLC-0104", name: "乌木", hex: "#0b0c0e", rgb: "11 · 12 · 14", cmyk: "40 · 30 · 20 · 92", categoryId: "carbon", lightness: 10, sheen: "半光", tone: "冷调", tags: ["蓝黑", "深邃"], use: ["汽车", "饰面"], desc: "乌木在暗部带一丝冷青底蕴，让大面积深色不再单一，常用于车漆与金属饰面。" },

  // 曜石系
  { id: "s05", code: "HLC-0201", name: "曜黑", hex: "#101014", rgb: "16 · 16 · 20", cmyk: "30 · 30 · 20 · 92", categoryId: "obsidian", lightness: 9, sheen: "高光", tone: "冷调", tags: ["曜石", "高光"], use: ["数码", "汽车"], desc: "如打磨后的曜石，冷调高光在黑中透出细密光泽，是高端电子外壳的常见选择。" },
  { id: "s06", code: "HLC-0202", name: "黑曜", hex: "#14141a", rgb: "20 · 20 · 26", cmyk: "25 · 22 · 10 · 90", categoryId: "obsidian", lightness: 14, sheen: "高光", tone: "冷调", tags: ["冷黑", "光泽"], use: ["数码", "包装"], desc: "黑曜在反光下泛出淡淡冷蓝，让黑色外壳更具立体层次与科技感。" },
  { id: "s07", code: "HLC-0203", name: "琉璃墨", hex: "#0a0a12", rgb: "10 · 10 · 18", cmyk: "60 · 50 · 25 · 92", categoryId: "obsidian", lightness: 6, sheen: "高光", tone: "冷调", tags: ["极深", "蓝底"], use: ["饰面", "包装"], desc: "近似墨镜般的深黑，藏有微弱的紫蓝底调，适合需要神秘氛围的礼盒与外饰。" },
  { id: "s08", code: "HLC-0204", name: "亮漆黑", hex: "#1b1b20", rgb: "27 · 27 · 32", cmyk: "18 · 16 · 10 · 88", categoryId: "obsidian", lightness: 20, sheen: "高光", tone: "中性", tags: ["钢琴漆", "亮面"], use: ["家居", "汽车"], desc: "接近钢琴烤漆的亮黑，反射清晰、色泽饱满，多用于家具腿与精品饰件。" },

  // 石墨系
  { id: "s09", code: "HLC-0301", name: "石墨", hex: "#28282c", rgb: "40 · 40 · 44", cmyk: "10 · 8 · 5 · 82", categoryId: "graphite", lightness: 28, sheen: "哑光", tone: "中性", tags: ["石墨", "结构"], use: ["工业", "家居"], desc: "石墨是深灰的代表，兼顾沉稳与易用，是深色系里最先被选作基础结构的灰阶。" },
  { id: "s10", code: "HLC-0302", name: "岩灰", hex: "#333338", rgb: "51 · 51 · 56", cmyk: "8 · 6 · 4 · 78", categoryId: "graphite", lightness: 34, sheen: "哑光", tone: "中性", tags: ["岩灰", "耐脏"], use: ["建材", "户外"], desc: "岩灰肌理耐磨不易显尘，适合户外建材与公共空间的大面积饰面。" },
  { id: "s11", code: "HLC-0303", name: "铅灰", hex: "#3d3d42", rgb: "61 · 61 · 66", cmyk: "8 · 6 · 3 · 74", categoryId: "graphite", lightness: 41, sheen: "半光", tone: "中性", tags: ["半光", "过渡"], use: ["印刷", "数码"], desc: "铅灰处于明暗过渡的枢纽位，常用来衔接深黑与浅灰，建立版面层次。" },
  { id: "s12", code: "HLC-0304", name: "矿灰", hex: "#48484e", rgb: "72 · 72 · 78", cmyk: "10 · 7 · 3 · 69", categoryId: "graphite", lightness: 48, sheen: "哑光", tone: "中性", tags: ["矿灰", "中性"], use: ["家居", "数码"], desc: "矿灰带轻微冷意又不失克制，是深浅之间最不容易出错的辅助灰。" },

  // 烟灰系
  { id: "s13", code: "HLC-0401", name: "浅烟", hex: "#8a8a8f", rgb: "138 · 138 · 143", cmyk: "4 · 3 · 2 · 44", categoryId: "smoke", lightness: 70, sheen: "哑光", tone: "冷调", tags: ["浅灰", "冷调"], use: ["家居", "版面"], desc: "浅烟透着清冷，适合用作网页与画册的辅助底色，让深色内容更醒目。" },
  { id: "s14", code: "HLC-0402", name: "雾灰", hex: "#9c9ca1", rgb: "156 · 156 · 161", cmyk: "3 · 3 · 1 · 37", categoryId: "smoke", lightness: 76, sheen: "哑光", tone: "中性", tags: ["雾灰", "中性"], use: ["家居", "印刷"], desc: "雾灰是中性的高级灰，大量用于柔和分割线与次要文字，让版面干净透气。" },
  { id: "s15", code: "HLC-0403", name: "云灰", hex: "#b4b4b8", rgb: "180 · 180 · 184", cmyk: "2 · 2 · 1 · 28", categoryId: "smoke", lightness: 84, sheen: "哑光", tone: "中性", tags: ["云灰", "浅淡"], use: ["饰面", "版面"], desc: "云灰明度高而安静，可作大面积衬底，托起深色主体形成温柔的明暗过渡。" },
  { id: "s16", code: "HLC-0404", name: "纸灰", hex: "#cbcbc9", rgb: "203 · 203 · 201", cmyk: "1 · 1 · 2 · 20", categoryId: "smoke", lightness: 90, sheen: "半光", tone: "暖调", tags: ["暖灰", "纸感"], use: ["包装", "印刷"], desc: "纸灰带一点点暖，接近艺术纸本身的颜色，适合用于米白底页面里做隐形分区。" },

  // 玄青·冷墨系
  { id: "s17", code: "HLC-0501", name: "玄青", hex: "#1b1e26", rgb: "27 · 30 · 38", cmyk: "50 · 38 · 12 · 85", categoryId: "ink", lightness: 20, sheen: "半光", tone: "冷调", tags: ["蓝黑", "沉稳"], use: ["数码", "汽车"], desc: "玄青在深灰里揉入清透的冷青，规避纯黑的生硬，是科技与商务场景的常客。" },
  { id: "s18", code: "HLC-0502", name: "黛青", hex: "#22252e", rgb: "34 · 37 · 46", cmyk: "45 · 33 · 12 · 82", categoryId: "ink", lightness: 25, sheen: "哑光", tone: "冷调", tags: ["黛青", "克制"], use: ["家居", "饰面"], desc: "黛青比玄青略亮，蓝意更含蓄，适合偏理性、低喧哗的室内与产品配色。" },
  { id: "s19", code: "HLC-0503", name: "夜岚", hex: "#171b23", rgb: "23 · 27 · 35", cmyk: "55 · 40 · 15 · 86", categoryId: "ink", lightness: 17, sheen: "高光", tone: "冷调", tags: ["夜蓝", "深邃"], use: ["汽车", "饰面"], desc: "夜岚偏夜间天空的深蓝黑，高光处尤为深邃，适合营造静谧高级的氛围。" },
  { id: "s20", code: "HLC-0504", name: "青墨", hex: "#2b3038", rgb: "43 · 48 · 56", cmyk: "35 · 25 · 8 · 78", categoryId: "ink", lightness: 30, sheen: "哑光", tone: "冷调", tags: ["青灰", "哑光"], use: ["家居", "工业"], desc: "青墨是冷灰与墨蓝的平衡点，哑光质感让它耐看且不抢主体。" },

  // 暖黑·酱褐系
  { id: "s21", code: "HLC-0601", name: "暖曜", hex: "#181412", rgb: "24 · 20 · 18", cmyk: "10 · 20 · 28 · 90", categoryId: "warm", lightness: 14, sheen: "半光", tone: "暖调", tags: ["暖黑", "柔和"], use: ["家居", "包装"], desc: "暖曜在极暗中藏一缕暖光，让黑色更有温度，常用于原木与皮具的搭配黑。" },
  { id: "s22", code: "HLC-0602", name: "焦糖黑", hex: "#241c17", rgb: "36 · 28 · 23", cmyk: "15 · 38 · 55 · 85", categoryId: "warm", lightness: 21, sheen: "哑光", tone: "暖调", tags: ["焦糖", "复古"], use: ["时装", "家居"], desc: "焦糖黑带有明显的棕褐底蕴，复古气息浓，适合皮料、木质与大地色组合。" },
  { id: "s23", code: "HLC-0603", name: "红木黑", hex: "#1e1512", rgb: "30 · 21 · 18", cmyk: "10 · 40 · 52 · 88", categoryId: "warm", lightness: 16, sheen: "哑光", tone: "暖调", tags: ["红木", "深沉"], use: ["饰面", "家居"], desc: "红木黑如陈年硬木，红色底蕴在弱光下温润，用于古典饰面与红木制品极搭。" },
  { id: "s24", code: "HLC-0604", name: "咖啡黑", hex: "#33261d", rgb: "51 · 38 · 29", cmyk: "12 · 45 · 62 · 79", categoryId: "warm", lightness: 27, sheen: "半光", tone: "暖调", tags: ["咖啡", "温暖"], use: ["包装", "时装"], desc: "咖啡黑温暖而饱满，比纯黑更有亲和力，是食饮与生活方式类包装的热门。" },
];

export type Scene = {
  icon: string;
  title: string;
  text: string;
  count: string;
};

export const scenes: Scene[] = [
  { icon: "ri-scissors-line", title: "高级时装", text: "以玄墨、曜黑构成利落的廓形底色，或让暖曜、红木黑贴合皮革与织物的温润表达。", count: "深色面料" },
  { icon: "ri-car-line", title: "汽车涂装", text: "乌木、曜黑与夜岚这类带冷底蕴的高光黑，能在车身上还原深邃、干净的漆面层次。", count: "高光车漆" },
  { icon: "ri-home-4-line", title: "家居建材", text: "岩灰、黛青与焦糖黑承担墙面、柜体与软装的视觉支点，沉稳且耐看。", count: "空间饰面" },
  { icon: "ri-smartphone-line", title: "消费电子", text: "亮漆黑与玄青配合哑光处理，减少指纹与反光，营造冷静克制的产品语言。", count: "产品外壳" },
  { icon: "ri-printer-line", title: "平面与包装", text: "京碳、纸灰控制印刷深底与留白，让包装在货架上拥有低调的高辨识度。", count: "印刷深底" },
  { icon: "ri-vip-crown-line", title: "工业与饰面", text: "石墨、矿灰兼顾耐磨与耐候，适合器械、家具五金与公共空间的长周期饰面。", count: "耐候材料" },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  { q: "黑料色图鉴里的色号是什么体系？", a: "图鉴采用自建的「HLC」编号体系，前缀 HLC 代表黑料色（HeiLiao Color），后四位中的前两位对应所属色系（01 炭黑、02 曜石、03 石墨、04 烟灰、05 玄青、06 暖黑），后两位为系内序号。该编号便于在文档、物料与设计中快速引用同一色号。" },
  { q: "RGB、CMYK、HEX 三个值分别应该怎么用？", a: "HEX 与 RGB 用于屏幕端的网页、UI 与数字设计；CMYK 用于印刷与实物打样。屏幕上看起来一样的一档黑色，落到印刷时可能因为分色和纸张不同而产生偏差，因此正式交付印厂前应以 CMYK 值为准。" },
  { q: "为什么屏幕上的纯黑和印刷出来的黑不一样？", a: "屏幕黑由发光像素构成，能显示到接近 #000000；而印刷黑受油墨与纸张限制，纯 100% K 常显得偏浅偏灰。若追求更实的印黑，可搭配 C/M/Y 做「富黑」，色号对照表里已给出可参考的分色值。" },
  { q: "如何避免图鉴色卡与实际物料偏色？", a: "同一档黑在不同显示器、纸张与涂料表面下观感不同。建议以硬件校色的显示器核对 RGB，并索要实物色卡在目标材质与光照下做最终确认，图鉴提供的是可复现的参数起点而非绝对保证。" },
  { q: "怎么在不同色系之间查找并对照色号？", a: "在首页图鉴区可通过顶部分类快速切换单一色系，也可直接搜索色号、名称或 HEX 值。若想横向比较不同色系的代表性深黑，可查看下方「跨系对照表」，从中快速定位底调冷暖和明度高低。" },
  { q: "哑光、半光、高光分别适合什么场景？", a: "哑光反光少、显高档，适合大而耐看的表面如墙面与外壳；高光反射清晰、色泽饱满，适合小面积点缀与展示类物件；半光则居于两者之间，兼顾质感与耐脏，是最通用的选择。" },
];

export type AboutPoint = {
  title: string;
  text: string;
};

export const aboutPoints: AboutPoint[] = [
  { title: "专注黑色系", text: "不贪多求全，只把黑这个色域研究透，按底调、明度与光泽做出一套清晰的类目骨架。" },
  { title: "可复现参数", text: "每个色号都附 HEX、RGB 与 CMYK，让设计到印刷的交接有据可依，减少反复打样试错。" },
  { title: "持续归档", text: "跟随流行与材质工艺持续收录新黑，帮从业者用一份不断更新的图鉴覆盖日常选色。" },
];

export const stats = [
  { num: "6", unit: "色系", label: "系统分类" },
  { num: "24", unit: "色号", label: "精选样本" },
  { num: "3", unit: "色值", label: "RGB·CMYK·HEX" },
  { num: "∞", unit: "场景", label: "持续延展" },
];